// Utilities to manage session storage for logout
// removeOnlyKeys: removes only the provided keys from storages and leaves everything else intact.
export function removeOnlyKeys(deleteKeys = []) {
  for (const k of deleteKeys) {
    try { localStorage.removeItem(k); } catch (_) {}
    try { sessionStorage.removeItem(k); } catch (_) {}
  }
}

export function confirmAndLogout(navigate = null, redirectTo = '/login', deleteKeys = ['user', 'session_token', 'access_token', 'refresh_token']) {
  const confirmar = window.confirm('🔒👋 ¿Cerrar sesión y volver al login?');
  if (!confirmar) return false;

  // Optionally call server-side logout here if needed
  try {
    // Remove only the specified keys (default: user + session_token)
    removeOnlyKeys(deleteKeys);
  } catch (_) {}

  if (typeof navigate === 'function') {
    try { navigate(redirectTo); } catch (_) { window.location.href = redirectTo; }
  } else {
    window.location.href = redirectTo;
  }
  return true;
}

export default { removeOnlyKeys, confirmAndLogout };
